<form [formGroup]="docrelaySettingsFG" class="grid grid-cols-2 gap-4 p-4">

    <mat-form-field appearance="outline">
        <mat-label>Company</mat-label>
        <input matInput formControlName="docrelayCompany" autocomplete="off" />
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Target</mat-label>
        <input matInput formControlName="docrelayTarget" autocomplete="off" />
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Username</mat-label>
        <input matInput formControlName="docrelayUserName" autocomplete="off" />
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="docrelayPassword" autocomplete="off" />
    </mat-form-field>


</form>